export enum SpinnerSize {
  TINY = "tiny",
  SMALL = "small",
  MEDIUM = "medium"
}

export enum SpinnerColor {
  PRIMARY = "var(--primary-color)",
  SECONDARY = "var(--secondary-color)",
  GRAY_4 = "var(--gray-4)",
  SUCCESS = "var(--color-success)"
}

export interface LoadingSpinnerProps {
  /** The size of the Spinner */
  size?: SpinnerSize;
  /** The color of the Spinner */
  color?: `var(${string})`;
  /** An optional data-testid prop for testing */
  "data-testid"?: string;
}

export type LoadingBubblesProps = Pick<
  LoadingSpinnerProps,
  "color" | "data-testid"
>;

export type LoadingSkeletonProps = {
  /**
   * The variant of the skeleton loader.
   * line: A single line skeleton loader (default).
   * multi-line: A container with multiple line skeleton loaders — that staggers widths and animation timings.
   * @default "line"
   */
  variant?: "line" | "multi-line";
  /**
   * The width of the skeleton loader. Can be any valid CSS width value (e.g., "100%", "200px", "10rem").
   * @default children ? "fit-content" : "100%"
   */
  width?: string;
  /**
   * The height of the skeleton loader. Can be any valid CSS height value (e.g., "20px", "2rem").
   * @default children ? "auto" : "1rem"
   */
  height?: string;
  /**
   * The maximum width of the skeleton loader. Can be any valid CSS max-width value (e.g., "100%", "200px", "10rem").
   * @default "100%"
   */
  maxWidth?: string;
  /**
   * If defined, the skeleton will render as an overlay on top of the children, with a semi-transparent background.
   * This is useful for indicating that the content is loading while still showing the underlying content.
   * Only applicable when `variant` is set to "line".
   * @default undefined
   */
  children?: React.ReactNode;
};
